import React from "react";
import { useAuth } from "../Store/AuthContext";

export default function CounterSection() {
  const { webSetting } = useAuth();
  return (
    <>
      <div className="countersection fix">
        <div className="container">
          <div className="gt-counter-wrapper">
            <div className="gt-counter wow fadeInUp" data-wow-delay=".2s">
              <h2>
                <span className="count">
                  {webSetting?.yearsOf_experience || ""}
                </span>
                +
              </h2>
              <p>Years Of Experience </p>
            </div>
            <div className="gt-counter wow fadeInUp" data-wow-delay=".4s">
              <h2>
                <span className="count">
                  {webSetting?.happy_customers || ""}
                </span>
                +
              </h2>
              <p>Happy Customers</p>
            </div>
            <div className="gt-counter wow fadeInUp" data-wow-delay=".6s">
              <h2>
                <span className="count">
                  {webSetting?.completed_construction || ""}
                </span>{" "}
                Lakh+
              </h2>
              <p>Sq. Ft. Completed Construction </p>
            </div>
            {/* <div className="gt-counter wow fadeInUp" data-wow-delay=".8s">
              <h2>
                <span className="count">20.5</span>k
              </h2>
              <p>Featured Projects</p>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
}
